import React, { useState } from "react";
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Button,
  Box,
  Drawer,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import SearchBar from "../../components/SearchBar";
import SwitchToggle from "../../components/SwitchToggle";
import AddIntroScreen from "../../Modals/addIntroScreen";
import { GridCloseIcon } from "@mui/x-data-grid";

interface AppIntroItem {
  id: number;
  image: string;
  title: string;
  description: string;
  status: "Enable" | "Disable";
}

const ManageAppIntro: React.FC = () => {
  const introList: AppIntroItem[] = [
    {
      id: 1,
      image: "/static/images/placeholder.png",
      title: "AI-Powered Shopping Experience",
      description:
        "Enjoy personalized recommendations, visual & voice search, and smart product suggestions.",
      status: "Enable",
    },
    {
      id: 2,
      image: "/static/images/placeholder.png",
      title: "AI-Powered Shopping Experience",
      description:
        "Enjoy personalized recommendations, visual & voice search, and smart product suggestions.",
      status: "Enable",
    },
    {
      id: 3,
      image: "/static/images/placeholder.png",
      title: "AI-Powered Shopping Experience",
      description:
        "Enjoy personalized recommendations, visual & voice search, and smart product suggestions.",
      status: "Disable",
    },
  ];

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openDrawer, setOpenDrawer] = useState<boolean>(false);
  const [selectedIntro, setSelectedIntro] = useState<AppIntroItem | null>(null);

  const handleCloseModal = (): void => setOpenModal(false);

  const handleOpenDrawer = (item: AppIntroItem) => {
    setSelectedIntro(item);
    setOpenDrawer(true);
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    setSelectedIntro(null);
  };

  return (
    <>
      <div className="main_title d_flex">
        <h1>Manage App Intro</h1>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm=""
              setDebouncedSearchTerm={() => { }}
              placeholder="Search..."
            />
          </div>

          <div className="right_s">
            <Button
              className="btn btn_primary"
              onClick={() => setOpenModal(true)}
            >
              <AddIcon /> Add New Intro
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>S.no</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Position</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {introList.map((item, index) => (
                <TableRow hover key={item.id}>
                  <TableCell>{index + 1}</TableCell>

                  <TableCell>
                    <img
                      src={item.image}
                      alt={item.title}
                      style={{
                        width: "40px",
                        height: "40px",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                  </TableCell>

                  <TableCell className="max_c2">
                    <p>{item.title}</p>
                  </TableCell>

                  <TableCell className="max_c2">
                    <p>{item.description}</p>
                  </TableCell>

                  <TableCell>
                    <SwitchToggle
                      defaultChecked={item.status === "Enable"}
                    />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => handleOpenDrawer(item)}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="View"
                        />
                      </IconButton>

                      <IconButton onClick={() => setOpenModal(true)}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>

                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>

                  <TableCell>
                    <DragHandleIcon style={{ cursor: "pointer" }} />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      {/* Add Modal */}
      <AddIntroScreen
        open={openModal}
        onClose={handleCloseModal}
        setOpen={setOpenModal}
      />

      {/* Drawer View */}
      <Drawer
        anchor="right"
        open={openDrawer}
        onClose={handleCloseDrawer}
        className="intro_drawer"
      >
        <div className="drawer_header" >
          <Typography variant="h6">View Intro Screen</Typography>
          <IconButton onClick={handleCloseDrawer}><GridCloseIcon /></IconButton>
        </div>
        <div className="drawer_body">
          {selectedIntro && (
            <>
              <figure>
                <img
                  src="/static/images/intro_bg_img.png"
                  alt={selectedIntro.title}
                />
              </figure>

              <div className="content_box">
                <Typography variant="h6">
                  {selectedIntro.title}
                </Typography>

                <Typography variant="body1">
                  {selectedIntro.description}
                </Typography>
              </div>
            </>
          )}
        </div>
      </Drawer>
    </>
  );
};

export default ManageAppIntro;